import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../theme-context';
import TabSettings from './details/TabSettings';
import Account from './tabs/Account';
import { AdminGuard } from '../../../guards/RolesGuard';

export const SETTINGS_TABS = [
    { name: 'Account Settings', value: 'account', element: <Account/> },
    // { name: 'AI Agents', value: 'ai_agents', element: <AiAgents/> },
    // { name: 'Billing', value: 'billing', element: <Billing/> },
]

const Settings = () => {
    const { theme } = useTheme();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<any>(SETTINGS_TABS?.[0])

    const onClickTab = (tab: any) => {
        setActiveTab(tab)
    }

    const onClickGoBack = () => {
        navigate('/claire-2')
    }

    return (
        <div className='min-h-[95vh]'>
            <div className='flex flex-row items-center cursor-pointer hover:opacity-80 mt-3 mb-8' onClick={onClickGoBack}>
                <img src={theme === 'dark'? '/assets/shared/arrow-back-white.svg': '/assets/shared/arrow-back.svg'} className={'object-contain w-[20px] mr-2'}/>
                <p className='dark:text-primary-dark'>Settings</p>
            </div>
            <TabSettings
                tabs={SETTINGS_TABS?.filter((item: any)=> (AdminGuard() || item?.value === 'account'))}
                activeTab={activeTab}
                onClickTab={onClickTab}
            />
            {activeTab?.element}
        </div>
    )
}

export default Settings;